import React, { useContext } from 'react';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { Link } from 'gatsby';

import context from '../../context/context';

import CartIcon from '../../assets/icons/cart.svg';

import './HeaderCart.scss';

const HeaderCart: React.FC = () => {
  const { products } = useContext(context);
  const breakpoints = useBreakpoint();

  return breakpoints.laptops ? (
    <Link className="header-cart" to="/cart">
      <CartIcon />
      {products?.length > 0 && <span className="header-cart-count">{products.length}</span>}
    </Link>
  ) : (
    <div className="header-cart">
      <CartIcon />
      {products?.length > 0 && <span className="header-cart-count">{products.length}</span>}
    </div>
  );
};

export default HeaderCart;
